'use strict';

import styles from "./scss/style.scss";
import Navigo from "navigo";
import validate from "validate.js";
import lightbox from "./js/lightbox-plus-jquery.min";
// import * from './js/jquery.min';
// import lightbox from "./js/lightbox.min"
import artez from "./js/requests";
import constraints from "./js/validation-constraints";
import Naflexibilityvigo from "./js/flexibility";
import velocity from "velocity-animate";
import $ from "jquery";
import * as utils from "./js/utils";
import * as gmaps from "./js/google-maps";
import "./js/polyfill";
import header from "./header.html";
import 'jquery-circle-progress';
import Promise from 'promise';
import analytics from './js/analytics'

window.loadmaps = () => {
      gmaps.initMap();
      adjustregionHeight();
      mapsLoaded = true;
}

var mapsLoaded = false;

// This is for artez and its iframe callback
function addEvent() {

  if (window.addEventListener) { // W3C DOM1
    window.addEventListener("message", function (event) {
      alert(event.data);
    }); // event.data contains ‘aDZSwameMvlxmNMexQCO2m4PQdA=.eyJQYXltZW50U3RhdHVzIjoiU3VjY2VlZGVkIiwiUGF5bWVudElEIjoxMjUyMzY2M30' or 'userCancelled' flag
  } else if (window.attachEvent) { // IE DOM
    window.attachEvent("onmessage", function (event) {
      alert(event.data);
    });
  };

};

function recreateMenus() {

  let a = $('.menulink-container').clone();
  if (a.length > 0) {
    $('#aside-content').prepend(a);
  }

  let btn = $('.menulink-container .login-btn');
  // let sidebtn = $('#aside-content .login-btn');
  let panel = $('.menulink-container .ccq-login-box');
  // let sidepanel = $('#aside-content .ccq-login-box');
  if (btn.length > 0) {
    console.log('length');
    btn.click((e) => {
      console.log('click');
      // e.stopPropagation();
      if (panel.hasClass('open')) {
        panel.removeClass('open');
      } else {
        panel.addClass('open');
      }
    });
    // sidebtn.click((e) => {
    //   if (sidepanel.hasClass('open')) {
    //     sidepanel.removeClass('open');
    //   } else {
    //     sidepanel.addClass('open');
    //   }
    // });
    $(document).click(function (event) {
      if ($(event.target).closest(panel).length === 0 && !$(event.target).hasClass('login-btn')) {
        if ($(panel).hasClass('open')) {
          panel.removeClass('open');
        }
      }
    });
  }
}

$(document).ready(function () {
  $('.banner--logo').after(header);
  recreateMenus();
  analytics.addAnalytics()
});

// lightbox.options({
//     'alwaysShowNavOnTouchDevices' : true
// });

/** ROUTER  */
var root = null;
var useHash = true; // Defaults to: false
var hash = '#!'; // Defaults to: '#'
var router = new Navigo(root, useHash, hash);
let regionElement = null;

router.on(function () {
  router.navigate('/event');
})

router.on('/',
  (params, query) => {
    console.log('hello landing page')
    console.log(query);
    console.log(params.location);
   
    // gmaps.google.maps.event.trigger(map1, 'resize');
    
  }, {
    before: (done, params) => {
      hideCurrent();
      //resetFormErrors(document.querySelector("form#login-form"));
      done();
    },
    after: (params) => {
      showPanel(['#s-landingpage']);
      regionElement = document.querySelector(".region-selection a.region-cairns");
      moveRegionPointer(regionElement);
      console.log('landing page after');
       if (mapsLoaded == true) {
      gmaps.reloadMap();
    }
    else {
      console.log("didn't need to load");
    } 
    }
  }).resolve();

router.on('/location/:region',
  (params, query) => {

    let height = 0;
    let regionEl = document.querySelector("#s-landingpage .region-container .span-content");
    let cairnsEl = document.querySelector("#s-landingpage .region.cairns");
    let sunshineEl = document.querySelector("#s-landingpage .region.sunshinecoast");

    switch (params.region.toLowerCase()) {
      case 'cairns':
        velocity(sunshineEl, {
          opacity: 0
        }, {
            duration: 200,
            complete: (elements) => {
              sunshineEl.classList.remove('active');
            }
          });

        velocity(cairnsEl, {
          opacity: 1
        }, {
            delay: 250,
            duration: 200,
            begin: () => {
              height = cairnsEl.clientHeight;
              // regionEl.style.height = (height + 'px');
              regionEl.style.height = ('auto');
              cairnsEl.classList.add('active');
            }
          });
        //height = jquery(cairnsEl).height();
        break;

      case 'sunshinecoast':
        // sunshineEl.classList.add('active');
        // cairnsEl.classList.remove('active');
        velocity(cairnsEl, {
          opacity: 0
        }, {
            duration: 200,
            complete: (elements) => {
              cairnsEl.classList.remove('active');
            }
          });

        velocity(sunshineEl, {
          opacity: 1
        }, {
            delay: 250,
            duration: 200,
            begin: () => {
              height = sunshineEl.clientHeight;
              // regionEl.style.height = (height + 'px');
              regionEl.style.height = ('auto');
              sunshineEl.classList.add('active');
            }
          });
        //height = sunshineEl.clientHeight;
        break;
      default:
        break;
    }
    //velocity(regionEl, {height: utils.getRandomInt(200, 800) }, { duration: 1000 })
  }, {
    before: (done, params) => {
      hideCurrent();
      done();
    },
    after: (params) => {
      showPanel(['#s-landingpage']);
      regionElement = null;
      switch (params.region.toLowerCase()) {
        case 'cairns':
          regionElement = document.querySelector(".region-selection a.region-cairns")
          break;
        case 'sunshinecoast':
          regionElement = document.querySelector(".region-selection a.region-sunshinecoast")
          break;
      }
      moveRegionPointer(regionElement);
      console.log('Showing ' + params.region + ' after');
      
    }
  }).resolve();
  
var dataLoaded = false;
router.on('/community',
  (params, query) => {
    console.log('hello community page');
    $('html,body').scrollTop(0);
    if (dataLoaded == false) {
        communityData();
        newsData();
        dataLoaded = true;
    }
  }, {
    before: (done, params) => {
      hideCurrent();
      //resetFormErrors(document.querySelector("form#login-form"));
      showPanel(['#s-community']);
      done();
    },
    after: (params) => {
      console.log('community page after');
    }
  }).resolve();

router.on('/community/news',
  (params, query) => {
    if (dataLoaded == false) {
        communityDataScroll();
        newsData();
        dataLoaded = true;
    }
  }, {
    before: (done, params) => {
      hideCurrent();
      //resetFormErrors(document.querySelector("form#login-form"));
      showPanel(['#s-community']);
      done();
    },
    after: (params) => {
    }
  }).resolve();

router.on('/login',
  (params, query) => {
    console.log('hello login')
  }, {
    before: (done, params) => {
      hideCurrent();
      resetFormErrors(document.querySelector("form#login-form"));
      showPanel(['#s-login']);
      done();
    },
    after: (params) => {
      console.log('login after');
    }
  }).resolve();
router.on('/forgot',
  (params, query) => {
    console.log('hello forgot')
  }, {
    before: (done, params) => {
      hideCurrent();
      showPanel(['#s-forgotpassword', '#s-forgotusername']);
      done();
    },
    after: (params) => { }
  }).resolve();
router.on('/register',
  (params, query) => {
    console.log('hello register')
  }, {
    before: (done, params) => {
      hideCurrent();
      showPanel(['#s-register']);
      done();
    },
    after: (params) => { }
  }).resolve();
router.on('/register/create-team',
  (params, query) => {
    console.log('hello team creator')
  }, {
    before: (done, params) => {
      hideCurrent();
      showPanel(['#s-createteam']);
      done();
    },
    after: (params) => { }
  }).resolve();
router.notFound(function () {
  console.log('route not found');
});
////////////////////////////////////////
/** LANDING PAGE SECTION */
window.addEventListener("load", () => {
  router.updatePageLinks();
  adjustregionHeight();
  frontTopData();
});
window.addEventListener("resize", () => {
  if (regionElement) {
    moveRegionPointer(regionElement);
    adjustregionHeight();
  }
})
function adjustregionHeight() {
  
  let regionEl = document.querySelector("#s-landingpage .region-container .span-content");
  let activeEl = document.querySelector("#s-landingpage .region.active");
  let height = activeEl.clientHeight;
  // regionEl.style.height = (height + 'px');
  regionEl.style.height = ('auto');
}
////////////////////////////////////////
/** COMMUNITY PAGE SECTION */

window.addEventListener("load", () => {
  checkIfDisplayTitle();
  checkIfIncreaseTriangle();
  checkIE();
  $(window).resize(checkIfDisplayTitle);
  $(window).resize(checkIfIncreaseTriangle);
});

 function goToByScroll(){
          $("html, body").animate({ scrollTop: $('.overall-container').offset().top }, 1000);
 }

function checkScrollPosition() {
  var device;
  if ($(window).width() < 640) {
    device = 300;
  }
  else {
    device = 500;
  }
  var target = ($("#leaderboards").offset().top) - device;
              var interval = setInterval(function() {
                if ($(window).scrollTop() >= target) {
                      enterResultsAmount();
                      enterIndLeaderboard();
                      enterTeamLeaderboard();
                      setTimeout(function() {
                          $(".gold-star").css("visibility", "visible");
                      }, 2000);
                      setTimeout(function() {
                          $(".backup-star").css("visibility", "visible");
                          $(".gold-star").css("visibility", "hidden");
                      }, 25000);
                       
                      
                      clearInterval(interval)
                 
                }
              }, 250);
}

function enterIndLeaderboard() {
    $('.results-amount:nth-of-type(1)').css("opacity", "1");
    var delay_time = 0;
    var count = 0;
    $("#leaderboards .results.individual-leaderboard li a").each(function() {
        if (count == 1) {
          delay_time = 800;
        }
        $(this).delay(delay_time).animate({marginLeft: '0px'}, 300);
        
        delay_time += 200;
        count++;
    });
}

function enterResultsAmount() {
        $(".results-amount").delay(1000).animate({opacity: '1'}, 1000);
}

function enterTeamLeaderboard() {
    var delay_time = 0;
    var count = 0;
    $("#leaderboards .results.team-leaderboard li a").each(function() {
      if (count == 1) {
          delay_time = 800;
        }
        $(this).delay(delay_time).animate({marginLeft: '0px'}, 300);
        delay_time += 200;
        count++;
    });
}
let individualData = null;
let teamData = null;
let frontDataIndividual = null;
let frontDataTeam = null;
let newsDataInfo = null;

function communityData() {
  console.log("loading ind data")
  artez.fetchIndividualLeaderboardData()
  .then((response) => {
    individualData = response;
    return artez.fetchTeamLeaderboardData()
  })
  .then((response) => {
    teamData = response;
    return renderCommunityElements(individualData, teamData);
  })
  .then((response) => {
    displayLeaderboards();
    checkScrollPosition();
    createRaisedChart();
    increaseNumber();
    adjustregionHeight();
  })
  .catch((e) => {
    console.log(e)
  })
}

function communityDataScroll() {
  console.log("loading ind data")
  artez.fetchIndividualLeaderboardData()
  .then((response) => {
    individualData = response;
    return artez.fetchTeamLeaderboardData()
  })
  .then((response) => {
    teamData = response;
    return renderCommunityElements(individualData, teamData);
  })
  .then((response) => {
    displayLeaderboards();
    checkScrollPosition();
    createRaisedChart();
    increaseNumber();
    adjustregionHeight();
    goToByScroll();
  })
  .catch((e) => {
    console.log(e)
  })
}

function checkIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        $(".loading-bubble").css("visibility", "hidden");
        $("#sunshine-coast-promotion").css("margin-top", "120px");
    }

    else {
       $(".loading-bubble").css("visibility", "visible");
    }
    // return false;
}

function displayLeaderboards() {
  $('.loading-mobile').css("display", "none");
  $('#loading').css("display", "none");
  $('#loading2').css("display", "none");
  $("#goal-info").css("visibility", "visible");
  $(".title-to-disappear").css("visibility", "visible");
  $('ul#individual-leaderboard').css("display", "block");
  $('ul#team-leaderboard').css("display", "block");
}

function hideLoadingLanding() {
   $('.loading-landing').hide();
}

function frontTopData() {
  artez.fetchIndividualLeaderboardData()
  .then((response) => {
    frontDataIndividual = response;
    return artez.fetchTeamLeaderboardData()
  })
  .then((response) => {
    frontDataTeam = response;
    return renderTopData(frontDataIndividual, frontDataTeam)
  })
  .then((response) => {
    hideLoadingLanding();
  })
  .catch((e) => {
    console.log(e)
  })
}


function newsData() {
  artez.getWordpressStories()
  .then((response) => {
    newsDataInfo = response;
    return renderNews(newsDataInfo);
  })
  .then((response) => {
    addViewMore();
    checkWidth();
    $(window).resize(checkWidth);
  })
  // .then((reponse) => {
  //   loadSlideShow();
  // })
  .catch((e) => {
    console.log(e)
  })
}

function addViewMore() {
  let newsElement = document.getElementById('news-articles');
        var viewMore = `<div class="view-all"><a href="https://cancerqld.org.au/news/category/walk-for-womens-cancers/" alt="View more"
                  class="btn route-link cta small-buttons pink-button" target="_blank">VIEW MORE STORIES</a></div>`;
        newsElement.insertAdjacentHTML('beforeend', viewMore) ;       
}

// function loadSlideShow() {
//   // var storyHeight = 0;
//   // $('.new-article-small').each(function() {
//   //   storyHeight += $(this).outerHeight();
//   // })
//   // console.log(storyHeight);

//   var newsHeight = $(".overall-container").height();

//   console.log(newsHeight);

//   // $(".image-slideshow").css("margin-top", newsHeight + 100 + "px");
//   $(".image-slideshow").css("display", "block");
// }

function renderNews(newsData) {

    return new Promise(function(resolve, reject) {
      var parsedNews = newsData;

      let article = null;
      let viewMore = null;
      let newsElement = document.getElementById('news-articles');
      let articleImage = "";
      // wordpress news articles
      for (var i = 0; i < 4; i++) {
        articleImage = "";
        if (parsedNews[i]["_embedded"]["wp:featuredmedia"]) {
          articleImage = parsedNews[i]["_embedded"]["wp:featuredmedia"][0].source_url
          articleImage = articleImage.split('https://cancerqld.org.au').pop()
          articleImage = 'https://cancerqld.blob.core.windows.net/site' + articleImage
        }

        var news = {
            "newsTitle": parsedNews[i].title.rendered,
            // "newsImage": parsedNews[i]["_embedded"]["wp:featuredmedia"][0].source_url,
            "newsImage": `<img src="${articleImage}">`,
            "newsDate":  parsedNews[i].date.substring(0, 10),
            // "newsDate": news.newsDate.format(news.newsDate),
            "newsExcerpt": parsedNews[i].excerpt.rendered,
            "newsLink": parsedNews[i].link,
        }
        
        if (articleImage == "") {
          news.newsImage =  `<div class="article-placeholder"></div>`
        }

        if (i < 2) {
            article = `<div class="new-article newscolumn ms-Grid-col ms-u-sm8 ms-u-md8 ms-u-lg8">
                            <div class="news-image">`
                              + news.newsImage +
                            `</div>
                            <h2>${news.newsTitle}</h2>
                            <p class="news-date">${news.newsDate}</p>
                            <p class="news-content">${news.newsExcerpt}</p>
                            <a href="${news.newsLink}" alt="Read more"
                                    class="btn route-link cta" target="_blank">READ MORE</a>
                        </div>`
        }

        if (i == 2) {
          if (news.newsExcerpt.length > 150) {
            news.newsExcerpt = news.newsExcerpt.substring(0, 100);
          }
          article = `<div class="new-article-small newscolumn ms-Grid-col ms-u-sm4 ms-u-md4 ms-u-lg4">
                          <div class="news-image">`
                            + news.newsImage +
                          `</div>
                          <h2>${news.newsTitle}</h2>
                          <p class="news-date">${news.newsDate}</p>
                          <p class="news-content">${news.newsExcerpt}...</p>
                          <a href="${news.newsLink}" alt="Read more"
                                  class="btn route-link cta small-buttons" target="_blank">READ MORE</a>
                      </div>`
        }

         if (i == 3) {
          if (news.newsExcerpt.length > 150) {
            news.newsExcerpt = news.newsExcerpt.substring(0, 100);
          }
          article = `<div class="new-article-small last-news newscolumn ms-Grid-col ms-u-sm4 ms-u-md4 ms-u-lg4">
                          <div class="news-image">`
                            + news.newsImage +
                          `</div>
                          <h2>${news.newsTitle}</h2>
                          <p class="news-date">${news.newsDate}</p>
                          <p class="news-content">${news.newsExcerpt}...</p>
                          <a href="${news.newsLink}" alt="Read more"
                                  class="btn route-link cta small-buttons" target="_blank">READ MORE</a>
                      </div>`
        }

        newsElement.insertAdjacentHTML('beforeend', article)
        resolve();
      }

    })
}

function renderTopData(tDataIndividual, tDataTeam) {
  return new Promise(function(resolve, reject) {
    // var parsedFrontTopIndividual = JSON.parse(tDataIndividual);
    // var parsedFrontTopTeam = JSON.parse(tDataTeam);
    var parsedFrontTopIndividual = tDataIndividual;
    var parsedFrontTopTeam = tDataTeam;

    var jsonTopIndividual = parsedFrontTopIndividual.ParticipantScoreBoard_collection.ParticipantScoreBoard;
    var jsonTopTeam = parsedFrontTopTeam.TeamScoreBoard_collection.TeamScoreBoard;
    var topIndividual = {
      "firstName": jsonTopIndividual[0].ParticipantFirstName,
      "lastName": jsonTopIndividual[0].ParticipantLastName,
      "amountRaised": parseInt(jsonTopIndividual[0].onlineTotalCollected).toFixed(2)
    }

    var topTeam = {
      "teamName": jsonTopTeam[0].TeamName,
      "amountRaised": parseInt(jsonTopTeam[0].OnlineTotalCollected).toFixed(2),
    }
    
    $("#top-individual-name").html(topIndividual.firstName + " " + topIndividual.lastName);
    $("#top-individual-amount").html("$" + topIndividual.amountRaised);

    $("#top-team-name").html(topTeam.teamName);
    $("#top-team-amount").html("$" + topTeam.amountRaised);

    resolve();
  })
}

function renderCommunityElements(iData, tData) {
    return new Promise(function(resolve, reject) {
    // getting individual leaderboard data
      // var parsedIndividual = JSON.parse(iData);
      // var parsedTeam = JSON.parse(tData);
      var parsedIndividual = iData;
      var parsedTeam = tData;

      // var totalCollected1, totalCollected2;
      
      //Populate progress bar
      var totalCollected = parsedIndividual.ParticipantScoreBoard_collection.ParticipantScoreBoard[0].eventOnlineTotalCollected;
      let amountRaised = document.getElementById('raised-count')
      // var totalLength = totalCollected.length;
      totalCollected = parseInt(totalCollected).toFixed(2);

      //totalCollected = totalCollected.toLocaleString('en');
     // let amount = parseInt($("#raised-count").text().replace(/,/, ""), 10);
      // totalCollected1 = totalCollected.slice(0,totalLength - 6); 
      // totalCollected2 = totalCollected.slice(totalLength - 6, totalLength); 
      // console.log(totalCollected1 + ',' + totalCollected2)
      
      amountRaised.insertAdjacentHTML('beforeend', totalCollected);




      //Populate individiual leaderboard
      var jsonIndividual = parsedIndividual.ParticipantScoreBoard_collection.ParticipantScoreBoard;
      var jsonTeam = parsedTeam.TeamScoreBoard_collection.TeamScoreBoard;

      let individualList = document.getElementById('individual-leaderboard');
      let teamList = document.getElementById('team-leaderboard');

      for (var i = 0; i < 5; i++) {
        let individualOption = null;
        let teamOption = null;
        var individual = {
          "firstName": jsonIndividual[i].ParticipantFirstName, 
          "lastName": jsonIndividual[i].ParticipantLastName,
          "amountRaised": parseInt(jsonIndividual[i].onlineTotalCollected).toFixed(2),
          "userLink": `https://secure.cancercouncilfundraising.org.au/registrant/FundraisingPage.aspx?registrationID=${jsonIndividual[i].RegistrationID}&langPref=en-CA&Referrer=%26Referrer%3dhttps%253a%252f%252fcancerqld.org.au%252fwalkforwomenscancers%252f`
        }

        var team = {
          "teamName": jsonTeam[i].TeamName ? jsonTeam[i].TeamName : "Anonymous",
          "amountRaised": parseInt(jsonTeam[i].OnlineTotalCollected).toFixed(2),
          "userLink": `https://secure.cancercouncilfundraising.org.au/registrant/TeamFundraisingPage.aspx?teamID=${jsonTeam[i].TeamID}`
        }

        if (individual.firstName == "") {
           individual.firstName = "Anonymous";
           individual.userLink = `https://secure.cancercouncilfundraising.org.au/registrant/search.aspx?eventid=49337&langpref=en-CA&Referrer=https%3a%2f%2fsecure.cancercouncilfundraising.org.au%2fregV2%2fregV2.aspx%3feventid%3d49337%26langpref%3den-CA`
        }

        if (team.teamName == "") {
           team.teamName = "Anonymous";
           team.userLink = `https://secure.cancercouncilfundraising.org.au/registrant/search.aspx?eventid=49337&langpref=en-CA&Referrer=https%3a%2f%2fsecure.cancercouncilfundraising.org.au%2fregV2%2fregV2.aspx%3feventid%3d49337%26langpref%3den-CA`
        }
        
        if (i == 0) {

          //Individual
            $("#top-individual-name").html(individual.firstName + " " + individual.lastName);
            $("#top-individual-amount").html("$" + individual.amountRaised);
            individualOption = `<li class="first-result"> <a class="first-button" href="${individual.userLink}"  target= "_blank">
                            <span class="gold-star-mobile">
                            <img src="https://cancerqld.blob.core.windows.net/content/landing-pages/wfwc/wordpress/img/spinningstar.gif"/>
                        </span>
                            <span class="results-name ms-Grid-col ms-u-sm12 ms-u-md12 ms-u-lg12">${individual.firstName} ${individual.lastName}
                            <br /><span class="results-amount">$${individual.amountRaised}</span></span>
                          </div></a></li>`

          //Team
            $("#top-team-name").html(team.teamName);
            $("#top-team-amount").html("$" + team.amountRaised);
            teamOption = `<li class="first-result first-team number-items"> <a class="first-button" href="${team.userLink}" target= "_blank">
                          <span class="gold-star-mobile">
                              <img src="https://cancerqld.blob.core.windows.net/content/landing-pages/wfwc/wordpress/img/spinningstar.gif"/>
                          </span>
                            <span class="results-name ms-Grid-col ms-u-sm12 ms-u-md12 ms-u-lg12">${team.teamName}<br /><span class="results-amount">$${team.amountRaised}</span></span></div>
                          </li>`
          }

          //Individual
          else if (i > 0) {
            individualOption = `<li class="star-after"> <a href="${individual.userLink}"  target= "_blank">
                            <span class="results-number ms-Grid-col ms-u-sm2 ms-u-md2 ms-u-lg2">0${(i + 1)}</span>
                            <span class="results-name ms-Grid-col ms-u-sm8 ms-u-md8 ms-u-lg8">${individual.firstName} ${individual.lastName}</span>
                            <span class="results-amount ms-Grid-col ms-u-sm2 ms-u-md2 ms-u-lg2">$${individual.amountRaised}</span>
                          </a></li>`
            
            //Team
            teamOption = `<li class="number-items"> <a href="${team.userLink}" target= "_blank">
                          <span class="results-number ms-Grid-col ms-u-sm2 ms-u-md2 ms-u-lg2">0${i + 1}</span>
                          <span class="results-name ms-Grid-col ms-u-sm8 ms-u-md8 ms-u-lg8">${team.teamName}</span><span class="results-amount ms-Grid-col ms-u-sm2 ms-u-md2 ms-u-lg2">$${team.amountRaised}</span>
                        </a></li>`
          }
          individualList.insertAdjacentHTML('beforeend', individualOption)
          teamList.insertAdjacentHTML('beforeend', teamOption)
      }

      resolve();
    })















    

      //  let numberItems = $("li.number-items").length;
      //   let i = 0;
      //     if (numberItems < 5) {
      //       let number = 5 - numberItems;
      //       for (i = 0; i < number; i++){
      //          let option = `<li> <a href="javascript:;">
      //                     <span class="results-number ms-Grid-col ms-u-sm2 ms-u-md2 ms-u-lg2">0${count + 2}</span>
      //                     <span class="results-name ms-Grid-col ms-u-sm8 ms-u-md8 ms-u-lg8">N/A</span><span class="results-amount ms-Grid-col ms-u-sm2 ms-u-md2 ms-u-lg2">N/A</span>
      //                   </a></li>`
      //       let list = document.getElementById('team-leaderboard')
      //       list.insertAdjacentHTML('beforeend', option)
      //       count++;
      //       }
      //     }
}

// community-page

// document.onload = communityData();

// document.querySelector('#community-page').addEventListener("click", () => loadLeaderboards());

////////////////////////////////////////
/** LOGIN SECTION */
let formLogin = document.querySelector("form#login-form");
//formFieldsUpdates(formLogin, constraints.login);
function regLogin() {
  let formUsed = formLogin;
  resetFormErrors(formUsed);
  let err = validate(formUsed, constraints.login);
  console.log(err);
  if (err) {
    showErrors(formUsed, err);
  } else {
    let creds = utils.serializeArray(formUsed);
    creds = Object.assign(...creds);
    //p = utils.arraytojson(p);
    console.log(creds);
    artez.login(creds)
      .then(() => { })
      .catch((err) => {
        console.log('there was an error with artez login');
        console.log(err);
        showFormError(formUsed, err);
      });
  }
}
// document.querySelector('#s-login #login-btn').addEventListener("click", () => regLogin());
////////////////////////////////////////
/** FORGOT PASSWORD SECTION */
let formForgotPW = document.querySelector("form#forgotpassword-form");
//formFieldsUpdates(formForgotPW, constraints.forgotpassword);
function regForgotPassword() {
  let formUsed = formForgotPW;
  resetFormErrors(formUsed);
  let err = validate(formUsed, constraints.forgotpassword);
  console.log(err);
  if (err) {
    showErrors(formUsed, err);
  } else {
    let userDetails = utils.serializeArray(formUsed);
    userDetails = Object.assign(...userDetails);
    //p = utils.arraytojson(p);
    console.log({
      "UserName": userDetails.recusername
    });
    artez.forgotPassword({
      "UserName": userDetails.recusername
    })
      .then(() => {
        console.info('// Reset email sent');
      })
      .catch((err) => {
        console.log('there was an error with sending you a reset email, please contact xxxx xxxx');
        console.log(err);
        showFormError(formUsed, err);
      });
  }
}
// document.querySelector('#s-forgotpassword #forgotpasword-btn').addEventListener("click", () => regForgotPassword());
////////////////////////////////////////
/** FORGOT USERNAME SECTION */
let formForgotUN = document.querySelector("form#forgotusername-form");
//formFieldsUpdates(formForgotUN, constraints.forgotusername);
function regForgotUsername() {
  let formUsed = formForgotUN;
  resetFormErrors(formUsed);
  console.log(constraints.forgotusername);
  let err = validate(formUsed, constraints.forgotusername);
  console.log(err);
  if (err) {
    showErrors(formUsed, err);
  } else {
    let userDetails = utils.serializeArray(formUsed);
    userDetails = Object.assign(...userDetails);
    //p = utils.arraytojson(p);
    console.log({
      "EmailAddress": userDetails.recemail
    });
    artez.forgotUsername({
      "EmailAddress": userDetails.recemail
    })
      .then(() => {
        console.info('// Reset email sent');
      })
      .catch((err) => {
        console.log('there was an error with sending you a reset email, please contact xxxx xxxx');
        console.log(err);
        showFormError(formUsed, err);
      });
  }
}
// document.querySelector('#s-forgotusername #forgotusername-btn').addEventListener("click", () => regForgotUsername());
/** REGISTER SECTION */
// bind Next link
// document.querySelector('#s-register #register-next').addEventListener("click", function() {
//   router.navigate('/register/create-team');
// })
let formRegister = document.querySelector("form#register-form");
//formFieldsUpdates(formRegister, constraints.register);
/** GLOBAL FUNCTIONS
 *  handy bits that are used by all panels in this app
 */
let regionBtns = document.querySelectorAll(".region-selection a.region-btn");
if (regionBtns) {
  regionBtns.forEach((element) => {
    element.addEventListener("click", (event) => moveRegionPointer(event.target));
  }, this);
}
/*
let regionElement = document.querySelectorAll(".region");
if(regionElement){
    regionElement.forEach((element)=>{
        element.addEventListener("transitionend", function(event) {
            console.log('transition done');
            event.target.style.display = "none";
        }, false);
    })
}
*/
function moveRegionPointer(element) {
  if (element) {
    let slider = document.querySelectorAll('.region-selection span.selection-pointer');
    let activeElement = element;
    let activeRegionWidth = activeElement.clientWidth;
    let activeRegionLeft = activeElement.offsetLeft;
    slider[0].style.width = (activeRegionWidth + 'px');
    slider[0].style.left = (activeRegionLeft + 'px');
    slider[0].style.opacity = 1;
    console.log(activeRegionWidth + 'px');
  }
}
function parentContainer(el, classname) {
  while (el.parentNode) {
    el = el.parentNode;
    if (el.className.includes(classname))
      return el;
  }
  return null;
}
function formFieldsUpdates(form, constraints) {
  let inputs = form.querySelectorAll("input:not([type='button'])");
  for (var i = 0; i < inputs.length; i++) {
    var element = inputs[i];
    element.addEventListener("change", (event) => {
      let thisID = event.target.id;
      let err = validate(form, constraints);
      if (err && err.hasOwnProperty(thisID)) {
        let msg = err[thisID];
        showErrors(form, {
          [thisID]: msg
        });
      } else {
        let parent = parentContainer(event.target, 'fieldset');
        if (parent.hasClass('error')) {
          parent.classList.remove('error');
        }
      }
    })
  }
}
function showErrors(form, err) {
  let input, container, errmsg;
  for (let key in err) {
    input = form.querySelector('#' + key);
    container = parentContainer(input, 'fieldset');
    if (container) {
      container.classList.add("error");
      if (container.querySelector(".err-msg")) {
        container.querySelector(".err-msg").innerText = err[key];
      } else {
        errmsg = document.createElement("div");
        errmsg.classList.add('err-msg');
        errmsg.innerText = err[key];
        container.appendChild(errmsg);
      }
    }
  }
}
function resetFormErrors(form) {
  let errors = form.querySelectorAll(".error");
  let errorbox = form.querySelector('.form-error');
  errorbox.innerText = '';
  errorbox.classList.remove('active');
  console.log(errors);
  if (errors) {
    for (var x = 0; x < errors.length; x++) {
      var element = errors[x];
      element.classList.remove('error');
    }
  }
}
function showFormError(form, msg) {
  let errorbox = form.querySelector('.form-error');
  errorbox.innerText = msg;
  errorbox.classList.add('active');
}
function hideCurrent() {
  let activeSection = document.body.querySelectorAll('div.section.active');
  for (let x = 0; x < activeSection.length; x++) {
    let element = activeSection[x];
    element.className = element.className.replace(' active', '');
  }
}
function showPanel(panels) {
  for (let x = 0; x < panels.length; x++) {
    let panelSelection = document.body.querySelector(panels[x]);
    if (panelSelection && panelSelection.className.indexOf(' active') < 0) {
      panelSelection.className = (panelSelection.className + ' active');
    }
  }
}

function createRaisedChart() {
  $("#background-chart").css("visibility", "visible");
  // let goal = parseInt($("#pink-title").replace(/,/g, "").text(), 10);
  let goal = parseInt($("#pink-title").text().replace(/,/, ""), 10);
  let amount = parseInt($("#raised-count").text().replace(/,/, ""), 10);
  let percentage = (1 / goal) * amount;
  $('#raised-chart').circleProgress({
    value: percentage,
    thickness: 30,
    emptyFill: 'transparent', 
    size: 250,
    fill: {
      gradient: ["#EC018A", "#fd68bf"]
    }
  });
}

// function createRaisedChart() {
//   // let goal = parseInt($("#pink-title").replace(/,/g, "").text(), 10);
//   let goal = parseInt($("#pink-title").text().replace(/,/, ""), 10);
//   let amount = parseInt($("#amount-raised-count").text().replace(/,/, ""), 10);
//   let percentage = (100 / goal) * amount;
//   $(".score-fill").css("width", percentage + "%");
// }

function increaseNumber() {
  $("#raised-text").css("display", "block");
  $("#raised-count").css("visibility", "visible");
  $('#raised-count').prop('Counter', 0).animate({
    Counter: $('#raised-count').text()
  }, {
      duration: 1000,
      easing: 'swing',
      step: function (now) {
        $(this).text(Math.ceil(now));
      }
    });
}

function format(inputDate) {
  var date = new Date(inputDate);
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  if (!isNaN(date.getTime())) {
    // Months use 0 index.
    return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
  }
}

function checkWidth() {
  let windowWidth = $(window).width();
  if (windowWidth < 1024) {
    $(".new-article").removeClass('ms-Grid-col ms-u-sm8 ms-u-md8 ms-u-lg8');
    $(".new-article-small").removeClass('ms-Grid-col ms-u-sm4 ms-u-md4 ms-u-lg4');
  }
  else if (windowWidth > 1024) {
    $(".new-article").addClass('ms-Grid-col ms-u-sm8 ms-u-md8 ms-u-lg8');
    $(".new-article-small").addClass('ms-Grid-col ms-u-sm4 ms-u-md4 ms-u-lg4');
  }
}

function checkIfDisplayTitle() {
  let windowWidth = $(window).width();
  if (windowWidth <= 1560 && windowWidth > 1024) {
    $(".title-to-disappear").html("We've<br/>raised");
  }
  else {
    $(".title-to-disappear").html("Together we've raised");
  }
}

function checkIfIncreaseTriangle() {
  let windowWidth = $(window).width();
  if (windowWidth < 1521) {
    $(".middle-triangle").css("border-top", "900px solid #ec018a");
  }
  else if (windowWidth > 1521) {
    $(".middle-triangle").css("border-top", "510px solid #ec018a");
  }
}



// WEBPACK FOOTER //
// ./src/app.js